import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

const DEFAULT_WORK_BADGE_VERIFICATION_PASSED_SCORE = 5;
const DEFAULT_WORK_BADGE_VERIFICATION_FAILED_OR_SKIPPED_SCORE = -5;

export function useWorkBadgeSettings() {
  return useCbhFlag(CbhFeatureFlag.CONFIGURE_WORK_BADGE_SETTINGS, {
    defaultValue: {
      workBadgeVerificationPassedScore: DEFAULT_WORK_BADGE_VERIFICATION_PASSED_SCORE,
      workBadgeVerificationFailedOrSkippedScore:
        DEFAULT_WORK_BADGE_VERIFICATION_FAILED_OR_SKIPPED_SCORE,
    },
  });
}
